import { render } from "./ScreenQuestionButtons.vue?vue&type=template&id=63a61106&scoped=true&ts=true"
import script from "./ScreenQuestionButtons.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionButtons.vue?vue&type=script&lang=ts"

import "./ScreenQuestionButtons.vue?vue&type=style&index=0&id=63a61106&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a61106"]])

export default __exports__